import { Routes } from '@angular/router';
import { TitleResolver } from '../resolver/metatitles/metatitles.resolver';
import { AutomationComponent } from '../../pages/automation/automation.component';
import { ProfileComponent } from '../../pages/profile/profile.component';
import { SettingComponent } from '../../pages/setting/setting.component';
import { RoleAccountGuard } from '../../guards/role-account.guard';
import { TagsComponent } from '../../pages/tags/tags.component';
import { MailComponent } from '../../pages/mail/mail.component';
import { NotificationRemindersComponent } from '../../pages/notification-reminders/notification-reminders.component';
import { OrderFreezeComponent } from '../../pages/order-freeze/order-freeze.component';
import { AccountImapComponent } from '../../pages/account-imap/account-imap.component';
import { VoipSettingsComponent } from '../../pages/voip/voip-settings/voip-settings.component';

export const settingsRoutes: Routes = [
  {
    path: 'settings',
    component: SettingComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.settings', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },

  },
  {
    path: 'settings/automation',
    component: AutomationComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.automations', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'settings/profile',
    component: ProfileComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.profile', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'settings/tags',
    component: TagsComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.tags', role: ['Admin', 'Supervisor', 'User'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'settings/mail',
    component: MailComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.mail', role: ['Admin'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'settings/notification-reminders',
    component: NotificationRemindersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.notification_reminders', role: ['Admin'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'settings/account-imap',
    component: AccountImapComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.account_imap', role: ['Admin'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'settings/voip-lines',
    component: VoipSettingsComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.voip_lines', role: ['Admin'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'settings/order-freeze',
    component: OrderFreezeComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.settings', role: ['Admin'], account_type: ['supplier'] },
  },
  {
    path: 'settings/automation/:reference',
    component: AutomationComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.automations', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
];

export function getFilteredSettingRoutes(accountType: string, role: string): Routes {
  return settingsRoutes.filter(route => {
    const allowedRoles = route.data?.['role'];
    const allowedAccountTypes = route.data?.['account_type'];
    const roleAllowed = !allowedRoles || allowedRoles.includes(role);
    const accountTypeAllowed = !allowedAccountTypes || allowedAccountTypes.includes(accountType);
    return roleAllowed && accountTypeAllowed;
  });
}
